import { ZIndex } from "emrn-design/ZIndex";
import React, { PureComponent } from "react";
import { View, Text, StyleSheet } from "react-native";
import { BottomPopup, BottomPopupInstance } from "emrn-design/BottomPopup";
import { EmTouchableText, EmTouchableOpacity } from "emrn-design/EmTouchable";

export class KeepOnlineTime extends PureComponent<{
  minutes: number;
  onChange: (minutes: number) => void;
}> {
  private popup = React.createRef<BottomPopup>();

  private handlePick = () => {
    let popInst: BottomPopupInstance | undefined;

    const destroy = () => {
      if (popInst) {
        popInst.dismiss();
        popInst = undefined;
      }
    };

    const onCancel = () => destroy();

    const onPicked = (minutes: number) => {
      destroy();
      minutes != this.props.minutes && this.props.onChange(minutes);
    };

    popInst = this.popup.current?.show(
      <PickOnlineMinutes {...{ onCancel, onPicked }} />,
      { zIndex: ZIndex.popup + 10 }
    );
  };

  render() {
    const { minutes } = this.props;
    return (
      <View style={styles.container}>
        <Text style={styles.text}>
          保持在线&nbsp;
          <EmTouchableText
            suppressHighlighting
            style={styles.text_time}
            onPress={this.handlePick}
          >
            {minutes}分钟
          </EmTouchableText>
        </Text>
        <BottomPopup ref={this.popup} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    justifyContent: "center",
    alignItems: "flex-end",
  },
  text: {
    color: "#666",
    fontSize: 14,
  },
  text_time: {
    color: "#3381e3",
    textDecorationLine: "underline",
  },
  pick: {
    width: "100%",
    backgroundColor: "#eee",
  },
  pick_item: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
  },
  pick_minutes: {
    height: 50,
    borderColor: "#eee",
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  pick_minutes_text: {
    color: "#333",
    fontSize: 14,
  },
  pick_cancel: {
    height: 40,
    marginTop: 10,
  },
  pick_cancel_text: {
    color: "#3381e3",
  },
});

function PickOnlineMinutes(props: {
  onCancel: () => void;
  onPicked: (minutes: number) => void;
}) {
  return (
    <View style={styles.pick}>
      {[15, 30, 60, 180].map((m) => (
        <EmTouchableOpacity
          key={m}
          activeOpacity={0.9}
          onPress={() => props.onPicked(m)}
          style={[styles.pick_item, styles.pick_minutes]}
        >
          <Text style={styles.pick_minutes_text}>{m}分钟</Text>
        </EmTouchableOpacity>
      ))}
      <EmTouchableOpacity
        activeOpacity={0.9}
        onPress={props.onCancel}
        style={[styles.pick_item, styles.pick_cancel]}
      >
        <Text style={styles.pick_cancel_text}>取消</Text>
      </EmTouchableOpacity>
    </View>
  );
}
